import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {getCurrentGroups} from "./lookWizardFunctions";


const LookWizardContentTitle = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

  if (wizardActiveStep === -1) {
    // return <FormattedMessage id="wizard.step.selectTitle" values={{wizardName: wizardActiveItem.name}}/>
    return wizardActiveItem.name
  }
  if (wizardActiveStep > -1 && currentGroups.length === 1) {
    return currentGroups[0].title
  }
  if (wizardActiveStep > -1 && !currentGroups.length) {
    return <FormattedMessage id="wizard.completed.title" values={{wizardName: wizardActiveItem.name}}/>
  }
  if (wizardActiveStep === 0 && currentGroups.length > 1 && wizardActiveItem.startTitle) {
    return wizardActiveItem.startTitle
  }
  return null
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  return {
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
  };
};

export default connect(mapStateToProps)(LookWizardContentTitle)
